// 瀬戸内海は、数値予報は別のモデルを出す
export const pointTypesForcast = [
  "WKJ0111",
  "WKJ0112",
  "WKJ0113",
  "WKJ0114",
  "WKJ0115",
  "WKJ0116",
  "WKJ0117",
  "WKJ0118",
  "WKJ0119",
  "WKJ0120",
  "WKJ0121",
  "WKJ0124",
  "WKJ0122",
  "WKJ0123",
  "WKJ0125",
];

// 短期予報を先に出すポイント
export const firstSortTermForcast = [
  "WKJ0132",
  "WKJ0133",
  "WKJ0134",
]

export default pointTypesForcast;

